import { useEffect, useRef } from 'react';

const useUpdateEffect = (callback: () => void, dependencies: any[]): void => {
	const first = useRef(true);

	useEffect(() => {
		if (first.current) {
			first.current = false;
			return;
		}
		return callback();
	}, dependencies);
};

export { useUpdateEffect };
